import { useAsyncData } from 'shared/hooks/useAsyncData';
import { TOURNAMENTS } from 'modules/jogador/tournaments/content';
import { fetchTournaments } from 'modules/jogador/tournaments/tournamentsService';

export function useTournamentsList() {
  const { data: tournaments, isLoading, error } = useAsyncData(fetchTournaments, TOURNAMENTS);
  return { tournaments, isLoading, error };
}
